export default "/images/vendor/flag-icons/flags/4x3/dz.svg?0f0875827805c6719abb646001357855";